import { Tokens } from '../mirrorful/theme'
import { Text as ChakraText } from '@chakra-ui/react'

export default function Text({children,
  classname,
    size,
    style,as,id,}){
    let fontSize = '22px'
  if (size === 'md') {
    fontSize = '18px'
  } else if (size === 'sm') {
    fontSize = '14px'
  }

  return (
    <ChakraText id={id} as={as} style={style} fontSize={fontSize} className={classname}>
      {children}
    </ChakraText>
  )
}